import { toDateString } from './toDateString';
import { getDatePartsAsNumbers } from './getDatePartsAsNumbers';

/**
 * Get the date for a date string.
 * @param input a string, expected to be a valid DateString, such as '2020-01-31'
 */
export const getDateFromDateString = (input: string): Date => {
    const dateAsDateString = toDateString(input);
    const dateParts = getDatePartsAsNumbers(dateAsDateString);

    if (dateParts === null) {
        throw new Error('Input was not a DateString');
    }

    return new Date(
        dateParts.year,
        // months are zero-indexed
        dateParts.month - 1,
        dateParts.day,
        0,
        0,
        0,
        0,
    );
};
